<div class="row" [nbSpinner]="loading" nbSpinnerStatus="info">
  <div
    class="col-12"
    *ngIf="(userService.$isAuthenticated | async) && qna.status != -1"
  >
    <nb-card>
      <nb-card-body>
        <form [formGroup]="replyForm">
          <div *ngIf="reply.toUid" class="form-group">
            <ngx-view-user-display
              [user]="reply.toAuthor"
              [mode]="'name'"
              [icon]="'at-outline'"
            >
            </ngx-view-user-display>
          </div>
          <div class="form-group">
            <ngx-editor-document
              formControlName="content"
              [(ngModel)]="reply.content"
            ></ngx-editor-document>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer>
        <button
          type="submit"
          nbButton
          shape="semi-round"
          status="primary"
          size="small"
          [disabled]="submitted || !replyForm.valid"
          [class.btn-pulse]="submitted"
          (click)="createReply()"
        >
          Gửi câu trả lời
        </button>
      </nb-card-footer>
    </nb-card>
  </div>

  <div *ngFor="let item of qnaReplies; let i = index" class="col-12">
    <nb-card [nbSpinner]="item.loading" nbSpinnerStatus="info">
      <nb-card-header>
        <div class="summary">
          <div class="item">
            <div class="avatar">
              <ngx-view-user-display
                [user]="item.author"
                [mode]="'avatar'"
              ></ngx-view-user-display>
            </div>

            <div class="content">
              <div class="content-header">
                <div>
                  <ngx-view-user-display
                    [user]="item.author"
                    [mode]="'name'"
                  ></ngx-view-user-display>
                  <ngx-view-time-ago
                    [currentDate]="item.createdOn"
                  ></ngx-view-time-ago>
                </div>

                <div class="button-action">
                  <button
                    *ngIf="!item.editing && item.createdBy === uid"
                    nbButton
                    ghost
                    status="danger"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="deleteReply(item)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>

                  <button
                    *ngIf="item.createdBy === uid && !item.editing"
                    nbButton
                    ghost
                    status="info"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="onEditReply(item)"
                  >
                    <nb-icon icon="edit-2-outline"></nb-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="item.toUid" class="text-link">
                <ngx-view-user-display
                  [user]="item.toAuthor"
                  [mode]="'name'"
                  [icon]="'at-outline'"
                >
                </ngx-view-user-display>
              </div>

              <div *ngIf="!item.editing" class="view-content">
                <nb-card>
                  <nb-card-body>
                    <ngx-view-document [content]="item.content">
                    </ngx-view-document>
                  </nb-card-body>
                </nb-card>
              </div>

              <div *ngIf="item.editing" class="view-content">
                <ngx-editor-document
                  [(ngModel)]="content"
                ></ngx-editor-document>

                <div class="button-actions">
                  <button
                    type="submit"
                    nbButton
                    fullWidth
                    outline
                    shape="semi-round"
                    status="primary"
                    size="small"
                    [disabled]="submitted || content.length <= 0"
                    [class.btn-pulse]="submitted"
                    (click)="editReply(item)"
                  >
                    Lưu
                  </button>

                  <button
                    type="submit"
                    nbButton
                    fullWidth
                    outline
                    shape="semi-round"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="cancelReply(item)"
                  >
                    Hủy
                  </button>
                </div>
              </div>

              <div *ngIf="!item.editing" class="button-actions">
                <ngx-view-like [qnaReply]="item"> </ngx-view-like>

                <ngx-button-report-spam
                  [qnaReply]="item"
                  (onReport)="report($event)"
                ></ngx-button-report-spam>
              </div>
            </div>
          </div>
        </div>
      </nb-card-header>
    </nb-card>
  </div>

  <div class="col-12" *ngIf="loading">
    <ngx-view-placeholder></ngx-view-placeholder>
  </div>

  <div class="col-12">
    <nb-actions size="small" class="see-more-button">
      <nb-action
        [disabled]="(userService.$isAuthenticated | async) && qna.status != -1"
        (click)="onNewReply(null)"
      >
        <nb-icon class="action-icon" icon="bulb-outline"></nb-icon>
        <span
          *ngIf="(userService.$isAuthenticated | async) && qna.status != -1"
          class="text-link"
          >Gửi câu trả lời</span
        >
      </nb-action>

      <nb-action *ngIf="!done" (click)="loadMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>

      <nb-action (click)="closeReplies()">
        <nb-icon class="action-icon" icon="chevron-up-outline"></nb-icon>
        <span class="text-link">Thu gọn</span>
      </nb-action>
    </nb-actions>
  </div>
</div>
